/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isbackgroundblurringenabledbydefault5Inputs */

const en_entity_isbackgroundblurringenabledbydefault5 = /** @type {(inputs: Entity_Isbackgroundblurringenabledbydefault5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Background Blurring Enabled By Default`)
};

const de_entity_isbackgroundblurringenabledbydefault5 = /** @type {(inputs: Entity_Isbackgroundblurringenabledbydefault5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundunschärfe standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Background Blurring Enabled By Default" |
*
* @param {Entity_Isbackgroundblurringenabledbydefault5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isbackgroundblurringenabledbydefault5 = /** @type {((inputs?: Entity_Isbackgroundblurringenabledbydefault5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isbackgroundblurringenabledbydefault5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isbackgroundblurringenabledbydefault5(inputs)
	return de_entity_isbackgroundblurringenabledbydefault5(inputs)
});
export { entity_isbackgroundblurringenabledbydefault5 as "entity_isBackgroundBlurringEnabledByDefault" }